import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('group_by_any_fields_technical');
	},
};
